// extracted by css-extract-rspack-plugin
module.exports =  {"tab":"TabButton-EqE5__tab","tab--active":"TabButton-x49e__tab--active","badge":"TabButton-Sa8c__badge"};